<template>
    <div class="schedule__list">
        <div class="schedule__item" v-for="doctor in doctorList" :key="doctor">
            <div class="schedule__profile">
                <img :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor?.attachBag?.thumbs" onerror="this.style.display='none'">
            </div>
            <div class="schedule__cont">
                <div class="schedule__info">
                    <div class="schedule__profile-mo">
                        <img :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor?.attachBag?.thumbs" onerror="this.style.display='none'">
                    </div>
                    <div class="schedule__mo-cont">
                        <h4 class="schedule--name">{{doctor.drName ? doctor.drName : doctor.name}} 교수</h4>
                        <p class="schedule--department">{{doctor.belong}}</p>
                        <template v-if="doctor.detailField">
                            <h4 class="schedule--clinic">전문진료분야</h4>
                            <p class="schedule--desc">{{doctor.detailField}}</p>
                        </template>
                    </div>

                    <table class="schedule__table">
                        <colgroup>
                            <col style="width: calc(100% / 7);">
                            <col style="width: calc(100% / 7);">
                            <col style="width: calc(100% / 7);">
                            <col style="width: calc(100% / 7);">
                            <col style="width: calc(100% / 7);">
                            <col style="width: calc(100% / 7);">
                            <col style="width: calc(100% / 7);">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>시간</th>
                                <th v-for="day in ['월', '화', '수', '목', '금', '토']" :key="day">{{ day }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="period in ['오전', '오후']" :key="period">
                                <th>{{ period }}</th>
                                <td v-for="dayIndex in 6" :key="dayIndex">
                                    <div class="schedule__cell">
                                        <span :class="getScheduleStatus(doctor.schedule, period, dayIndex)">
                                            {{ getScheduleStatus(doctor.schedule, period, dayIndex).indexOf('dayoff') > -1 ? '휴' :
                                            getScheduleStatus(doctor.schedule, period, dayIndex).indexOf('holiday') > -1 ? '공' : '' }}
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="schedule__buttons">
                    <button class="schedule__btn type01" @click="getDoctorReserveDate(doctor, 'N')" v-if="checkRsv(doctor)">진료예약</button>
                    <button class="schedule__btn type02" @click="getDoctorReserveDate(doctor, 'Q')" v-if="checkRsv(doctor)">빠른예약</button>
                    <button class="schedule__btn type03" @click="goDoctorInfo(doctor)">의료진소개</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    props: {
        doctorList: [],
    },
    data() {
        return {
            deptCd: this.$route.query.deptCd || ''
        }
    },
    methods: {
        goDoctorInfo(doctor){
            window.open(`/kr/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.deptCd ? doctor.deptCd : doctor.mainDeptCd}`, '_blank')
        },
        checkRsv(doctor){
            if(this.$store.getters.getHost != 'H0009'){
                return true
            }
            if(doctor?.appointYn != 'Y'){
                return false
            }
            if(doctor?.doctorDeptList?.length > 0){
                for(let i of doctor.doctorDeptList){
                    if(i.deptType == '0'){
                        return i.rsvYn == 'Y'
                    }
                }
            }else if(doctor?.doctorDept?.rsvYn == 'Y'){
                return true
            }
            return false
        },
        getDoctorReserveDate(doctor, type){
            this.axios.get(this.api.doctor.getDate, {
                params: {
                    drSid: doctor.drSid
                }
            })
            .then(res => {
                const data = res.data
                if(data.code == 'OK'){
                    if(type == 'N'){
                        this.$store.state.reserveStore.normalReserve = doctor
                    }
                    if(type == 'Q'){
                        this.$store.state.reserveStore.quickReserve = doctor
                    }
                    this.$store.state.patInfoStore = {}
                    this.$router.push('/kr/reserve/reservation')
                }else{
                    alert(data.result)
                    if(data.code == 'not login'){
                        this.$router.push('/kr/login')
                    }
                }
            })
        },
        getScheduleStatus(schedule, period, dayIndex) {
            if (!schedule || !Array.isArray(schedule)) return '';
            
            const filteredSchedule = schedule.find(item => 
                item.MED_TP === period && 
                new Date(item.MED_DT).getDay() === dayIndex
            );
            
            if (!filteredSchedule) return '';
            
            if (filteredSchedule.HOLY_YN === 'N' && filteredSchedule.NSP_RSN_TP_CD === 'N') {
                return filteredSchedule.CLNC_YN === 'N' ? 
                'schedule__legend-icon schedule__legend-icon--outpatient' : 
                'schedule__legend-icon schedule__legend-icon--clinic';
            } else if (filteredSchedule.HOLY_YN === 'Y' && filteredSchedule.NSP_RSN_TP_CD === 'Y') {
                return 'schedule__legend-icon schedule__legend-icon--holiday';
            } else {
                return 'schedule__legend-icon schedule__legend-icon--dayoff';
            }
        }
    },
}
</script>